import DictionaryDetailContainer from 'components/DictionaryDetail/DictionaryDetailContainer'
import DictionaryDetailData from 'components/DictionaryDetail/DictionaryDetailData'
import DictionaryDetailPresentation from 'components/DictionaryDetail/DictionaryDetailPresentation'
import DictionaryDetailPresentationDrawer from 'components/DictionaryDetail/DictionaryDetailPresentationDrawer'
import DictionaryDetailPresentationKids from 'components/DictionaryDetail/DictionaryDetailPresentationKids'

export default {
  Container: DictionaryDetailContainer,
  Data: DictionaryDetailData,
  Presentation: DictionaryDetailPresentation,
  PresentationDrawer: DictionaryDetailPresentationDrawer,
  PresentationKids: DictionaryDetailPresentationKids,
}
